/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AppsListAppsResponse = {
  result: components.V1AppsListAppsResponseBody;
};

/** @internal */
export const AppsListAppsResponse$inboundSchema: z.ZodType<
  AppsListAppsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Result: components.V1AppsListAppsResponseBody$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Result": "result",
  });
});

export function appsListAppsResponseFromJSON(
  jsonString: string,
): SafeParseResult<AppsListAppsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AppsListAppsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AppsListAppsResponse' from JSON`,
  );
}
